import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'

export default class Event {
  static api = api.create(Event)

  constructor({
    id = null,
    title = '',
    photo = null,
    shortDescription = null,
    fullDescription = null,
    date = null,
    secondaryPhotos = [],
  } = {}) {
    Object.assign(this, {
      id,
      title,
      photo,
      shortDescription,
      fullDescription,
      date,
      secondaryPhotos,
    })
  }

  copy() {
    return new Event(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Event(data)
  }

  static fromAPI(json = {}) {
    return new Event(objectToCamelCase(json))
  }

  /**
   *  Prep data for the API.
   **/
  static toAPI(event, fields = []) {
    // By default, send the whole event
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = event[field]
      })
    } else {
      data = event
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Event)) {
      throw Error(`${name} must be an instance of the Event class.`)
    }
  }
}
